<template>
	<div class="grid">

    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#274461"
      :is-full-page="fullPage"
    ></loading>
       <div class="col-12">
        <div class="card">          
          <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems">
                <!--<template #item="{ item, props }">
                    <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
                        <a :href="href" v-bind="props.action" @click="navigate">
                            <span :class="[item.icon, 'text-color']" />
                            <span class="text-primary font-semibold">{{ item.label }}</span>
                        </a>
                    </router-link>
                </template>-->
                <template #item="{ item, props }">
                    <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
                        <a :href="href"  @click="navigate">
                            <span :class="[item.icon, 'text-color']" />
                            <span class="text-primary font-semibold">{{ item.label }}</span>
                        </a>
                    </router-link>
                    <a v-else :href="item.url" :target="item.target" v-bind="props.action">
                    <span class="text-color">{{ item.label }}</span>
                </a>
                </template>
            </Breadcrumb>
          <Toast />
              <div class="p-fluid formgrid grid" style="margin-top: 2%">
                  <div class="field col-12 md:col-2">                    
                      <span class="p-float-label">
                          <InputText type="text" v-model="search_name"></InputText>
                          <label for="name">Name</label>
                      </span>
                  </div>

                  <div class="field col-12 md:col-2">
                      <span class="p-float-label">
                          <Dropdown                                            
                              id="status"
                              v-model="search_status"
                              :options="status_dropdown"
                              :value="status_dropdown"
                              optionLabel="name"
                              filter
                          ></Dropdown>
                          <label for="status">Status</label>
                      </span>
                  </div>

                  <div class="field col-12 md:col-2">
                    <span class="p-float-label">                                      
                      <MultiSelect                                            
                        id="status"
                        v-model="type_selected"
                        :options="type_dropdown"
                        :value="type_dropdown"
                        optionLabel="name"
                        filter
                      ></MultiSelect>                                     
                      <label>Type</label>             
                    </span> 
                  </div>  
                      
                  <div class="field col-12 md:col-2">
                      <Button
                        style="background-color: #349CE4;border: 1px solid #349CE4;"
                        icon="pi pi-search"
                        @click="search(1)"
                        v-tooltip.bottom="'Search'"
                      />
                  </div>
              </div>
              <DataView 
                :value="products"
                :layout="layout"                
                :rows=rows
              >
                <template #empty>
                  <div class="text-center">
                    <b style="text-align:center">No records found.</b>
                  </div>
                </template>

                <template #header>
                    <div class=" flex flex-column md:flex-row md:justify-content-between md:align-items-center ">
                        <h5 class="m-0"><b> Advertize Master</b></h5>
                        <div>
                            <Button icon="pi pi-refresh" @click="search(2)" style="background-color: #349CE4; border: 1px solid #349CE4;"   v-tooltip.bottom="'Refresh'"/>
                            <Button icon="pi pi-plus" class="ml-2" style="background-color: #349CE4;" v-tooltip.bottom="'Add'" @click="openNew" />
                        </div>
                    </div>
                    <div style="text-align:right;font-weight:bold;margin-top: 1%;"><span>Total Advertize:</span>{{totalRecords}}</div>
                </template>                            

                <template #grid="slotProps">
                  <div class="grid grid-nogutter" v-if="slotProps.items">
                  <div class="col-12 md:col-4" v-for="(item, index) in slotProps.items" :key="index">                    
                    <div class="card m-3 border-1 surface-border">  
                    <div style="margin-bottom: 5%;">
                      <span v-if="item.status=='Active' ||item.status=='active'"><badge :value=item.status severity="success"></badge></span>
                            <span v-else-if="item.status=='InActive' ||item.status=='In Active'"><badge :value=item.status severity="warning"></badge></span>
                            <span v-else-if="item.status=='Delete' ||item.status=='Deleted'"><badge :value=item.status severity="danger"></badge></span>
                            <span v-else>-</span>
                    </div>
                                       
                      <div class="text-center">
                        <div class="image-wrapper">
                          <img v-if="item.type=='image'" :src="item.url" alt="Image"  style="max-width: 80%; max-height: 10rem;" />
                          <iframe v-else-if="item.type=='video'" :src="item.url" frameborder="0" allowfullscreen  style="max-width: 80%; max-height: 10rem;"></iframe>
                        </div>
                        <div style="height: 50px;">
                          <p class="text-2xl font-bold">{{capitalizeFirstLetter(item.name)}}({{item.type}})</p>
                          <!-- <p class="" style="font-size: 10; margin-top: -5%; font-weight: 500;">{{capitalizeFirstLetter(item.description)}}</p> -->
                        </div>
                        <!-- <div class="flex align-items-center justify-content-between" >                         
                            <p style="font-size: 15px; font-weight: 600;">{{item.type}}</p>
                            
                            <span v-if="item.status=='Active' ||item.status=='active'"><badge :value=item.status severity="success"></badge></span>
                            <span v-else-if="item.status=='InActive' ||item.status=='In Active'"><badge :value=item.status severity="warning"></badge></span>
                            <span v-else-if="item.status=='Delete' ||item.status=='Deleted'"><badge :value=item.status severity="danger"></badge></span>
                            <span v-else>-</span>
                        </div> -->
                      </div>
                      <div class="flex align-items-center justify-content-between">
                        <button 
                          style="background-color: white; border: 1px solid #349CE4; color: #349CE4;"
                          class="p-button p-button-sm flex-auto" 
                          type="button"
                          @click="editProduct(item)"
                        >
                          <span class="p-button-icon p-button-icon-left pi pi-pencil" style="margin-left: 20%;"></span>
                          <span class="p-button-label" data-pc-section="label" style="margin-left: -20%;">Edit</span>
                        </button>

                        <button 
                          style="background-color: #349CE4; border: 1px solid #349CE4;"
                          class="p-button p-button-sm flex-auto ml-2" 
                          type="button"
                          @click="confirmDeleteProduct(item)"
                        >
                          <span class="p-button-icon p-button-icon-left pi pi-trash" style="margin-left: 20%;"></span>
                          <span class="p-button-label" data-pc-section="label" style="margin-left: -20%;">Delete</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 md:col-4" v-else>                    
                    <div class="card m-3 border-1 surface-border">                     
                      <div class="text-center">
                        <div class="image-wrapper">
                          <img v-if="slotProps.data.type=='image'" :src="slotProps.data.url" alt="Image"  style="max-width: 80%; max-height: 10rem;" />
                          <iframe v-else-if="slotProps.data.type=='video'" :src="slotProps.data.url" frameborder="0" allowfullscreen  style="max-width: 80%; max-height: 10rem;"></iframe>
                          <span v-else>-</span>
                        </div>
                        <div >
                          <p class="text-2xl font-bold">{{capitalizeFirstLetter(slotProps.data.name)}}</p>
                          <p class="" style="font-size: 15; margin-top: -5%; font-weight: 500; height: 20px;">{{capitalizeFirstLetter(slotProps.data.description)}}</p>
                        </div>
                        <div class="flex align-items-center justify-content-between">                         
                            <p style="font-size: 15px; font-weight: 600;">{{slotProps.data.type}}</p>
                            <span v-if="slotProps.data.status=='Active' ||slotProps.data.status=='active'"><badge :value=slotProps.data.status severity="success"></badge></span>
                            <span v-else-if="slotProps.data.status=='InActive' ||slotProps.data.status=='In Active'"><badge :value=slotProps.data.status severity="warning"></badge></span>
                            <span v-else-if="slotProps.data.status=='Delete' ||slotProps.data.status=='Deleted'"><badge :value=slotProps.data.status severity="danger"></badge></span>
                            <span v-else>-</span>
                          </div>
                        </div>
                      <div class="flex align-items-center justify-content-between">
                        <button 
                          style="background-color: white; border: 1px solid #349CE4; color: #349CE4;"
                          class="p-button p-button-sm flex-auto" 
                          type="button"
                          @click="editProduct(slotProps.data)"
                        >
                          <span class="p-button-icon p-button-icon-left pi pi-pencil" style="margin-left: 20%;"></span>
                          <span class="p-button-label" data-pc-section="label" style="margin-left: -20%;">Edit</span>
                        </button>

                        <button 
                          style="background-color: #349CE4; border: 1px solid #349CE4;"
                          class="p-button p-button-sm flex-auto ml-2" 
                          type="button"
                          @click="confirmDeleteProduct(slotProps.data)"
                        >
                          <span class="p-button-icon p-button-icon-left pi pi-trash" style="margin-left: 20%;"></span>
                          <span class="p-button-label" data-pc-section="label" style="margin-left: -20%;">Delete</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
              </DataView>
              
              <!-- <DataView 
                :value="products" 
                :layout="layout"                 
                :rows="row"                
              >
                <template #empty>
                  <b style="text-align:center">No records found.</b>
                </template>

                <template #header>
                    <div class=" flex flex-column md:flex-row md:justify-content-between md:align-items-center ">
                        <h5 class="m-0"><b> Advertize Master</b></h5>
                        <div>
                            <Button icon="pi pi-refresh" @click="search(2)" style="background-color: #349CE4; border: 1px solid #349CE4;"   v-tooltip.bottom="'Refresh'"/>
                            <Button icon="pi pi-plus" class="ml-2" style="background-color: #349CE4;" v-tooltip.bottom="'Add'" @click="openNew" />
                        </div>
                    </div>
                    <div style="text-align:right;font-weight:bold"><span>Total Routes:</span>{{totalRecords}}</div>
                </template>                            

                <template #grid="slotProps">
                  <div v-if="slotProps.data" class="col-12 md:col-4">                    
                    <div class="card m-3 border-1 surface-border">                     
                      <div class="text-center">
                        <div class="image-wrapper">
                          <img v-if="slotProps.data.type=='image'" :src="slotProps.data.url" alt="Image"  style="max-width: 80%; max-height: 10rem;" />
                          <iframe v-else-if="slotProps.data.type=='video'" :src="slotProps.data.url" frameborder="0" allowfullscreen  style="max-width: 80%; max-height: 10rem;"></iframe>
                          <span v-else>-</span>
                        </div>
                        <div >
                          <p class="text-2xl font-bold">{{capitalizeFirstLetter(slotProps.data.name)}}</p>
                          <p class="" style="font-size: 15; margin-top: -5%; font-weight: 500; height: 20px;">{{capitalizeFirstLetter(slotProps.data.description)}}</p>
                        </div>
                        <div class="flex align-items-center justify-content-between">                         
                            <p style="font-size: 15px; font-weight: 600;">{{slotProps.data.type}}</p>
                            <span v-if="slotProps.data.status=='Active' ||slotProps.data.status=='active'"><badge :value=slotProps.data.status severity="success"></badge></span>
                            <span v-else-if="slotProps.data.status=='InActive' ||slotProps.data.status=='In Active'"><badge :value=slotProps.data.status severity="warning"></badge></span>
                            <span v-else-if="slotProps.data.status=='Delete' ||slotProps.data.status=='Deleted'"><badge :value=slotProps.data.status severity="danger"></badge></span>
                            <span v-else>-</span>
                          </div>
                        </div>
                      <div class="flex align-items-center justify-content-between">
                        <button 
                          style="background-color: white; border: 1px solid #349CE4; color: #349CE4;"
                          class="p-button p-button-sm flex-auto" 
                          type="button"
                          @click="editProduct(slotProps.data)"
                        >
                          <span class="p-button-icon p-button-icon-left pi pi-pencil" style="margin-left: 20%;"></span>
                          <span class="p-button-label" data-pc-section="label" style="margin-left: -20%;">Edit</span>
                        </button>

                        <button 
                          style="background-color: #349CE4; border: 1px solid #349CE4;"
                          class="p-button p-button-sm flex-auto ml-2" 
                          type="button"
                          @click="confirmDeleteProduct(slotProps.data)"
                        >
                          <span class="p-button-icon p-button-icon-left pi pi-trash" style="margin-left: 20%;"></span>
                          <span class="p-button-label" data-pc-section="label" style="margin-left: -20%;">Delete</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
              </DataView> -->
              <div class="pageno">
                <Paginator
                  :rows="rows"
                  :totalRecords="totalRecords"
                  :rowsPerPageOptions="[6, 9, 24, totalRecords]"
                  @page="onPageChange"
                ></Paginator>
              </div> 
                <Dialog
                  v-model:visible="productDialog"
                  @hide="reset"
                  :style="{ width: '1000px' }"
                  header="Advertize Form"
                  :modal="true"
                  >          
                  <div class="col-12">
                      <div class="card">
                          <div class="p-fluid formgrid grid">             
          
                              <div class="field col-12 md:col-6">
                                  <label for="name">Name</label>
                                  <InputText
                                      id="name"
                                      type="text"
                                      v-model.trim="product.name"
                                      required="true"                      
                                  />
                              </div>                            

                              <!-- <div class="field col-12 md:col-6">
                                  <label for="type">Type</label>
                                  <InputText
                                      id="type"
                                      type="text"
                                      v-model.trim="product.type"
                                      required="true"
                                      autofocus
                                      :class="{ 'p-invalid': submitted && !product.type }"
                                  />
                              </div> -->
                              <div class="field col-12 md:col-6">
                                  <label for="type">Type</label>
                                  <Dropdown                                            
                              id="status"
                              v-model="selected_type"
                              :options="type_dropdown"
                              :value="type_dropdown"
                              optionLabel="name"
                              filter
                          ></Dropdown>
                              </div>

                              <div class="field col-12 md:col-6">
                                  <label for="city">Description</label>
                                  <InputText
                                      id="description"
                                      type="text"
                                      v-model.trim="product.description"
                                      required="true"
                                      autofocus
                                  />
                              </div>  
                              
                              <div class="field col-12 md:col-6">
                                  <label for="short_description">Short Description</label>
                                  <InputText
                                      id="short_description"
                                      type="text"
                                      v-model.trim="product.short_description"
                                      required="true"
                                      autofocus
                                  />
                              </div>

                              <div class="field col-12 md:col-6">
                                  <label for="status">Status</label>
                                  <Dropdown
                                      id="status"
                                      v-model="selectedstatus"
                                      :options="status_dropdown"
                                      :value="status_dropdown.value"
                                      optionLabel="name"
                                      placeholder="Select One"
                                      :class="{ 'p-invalid': submitted && !selectedstatus }"
                                      required="true"
                                  ></Dropdown>
                              </div>

                              <div class="field col-6 md:col-3">
                                  <label for="menu_url">Image / Video</label>        
                                  <FileUpload
                                      class="p-button-primary"
                                      mode="basic"
                                      name="model[]"
                                      :auto="true"
                                      :custom-upload="true"
                                      choose-label="Choose"
                                      accept="image/*,video/*"
                                      @uploader="handleFileUpload($event)"
                                      style="
                                      box-shadow: 0 2px 6px rgba(0, 176, 176, 0.549);
                                      border-color: #00b0b0 !important;
                                      background-color: #00b0b0 !important;
                                      width: 100%;
                                      "
                                  />
                              </div> 
                                  
                              <div class="field col-6 md:col-3"  v-if="previewImage" style="padding-top: 20px;">                                                          
                                  <img v-if="isImage(previewImage)" :src="previewImage" alt="Image"  style="width: 200px; border: 2px solid #D3D3D3; overflow: hidden;" />
                                  <iframe v-else :src="previewImage" frameborder="0" allowfullscreen  style="width: 200px; border: 2px solid #D3D3D3;"></iframe>                
                              </div>                          
                          </div>
                      </div>
                  </div>
                      
                  <div class="col-12 md:col-6">
                      <Button
                          style="background-color: white; border: 1px solid #349CE4; color: #349CE4;"
                          v-if="product._id"
                          label="UPDATE"
                          icon="pi pi-check"
                          class="p-button mr-1 mb-1"
                          @click="adduser"
                      />
                      <Button
                          v-else
                          style="background-color: white; border: 1px solid #349CE4; color: #349CE4;"                          
                          label="ADD"
                          icon="pi pi-check"
                          class="p-button mr-1 mb-1"
                          @click="adduser"
                      />&nbsp;&nbsp;&nbsp;
                      <Button
                          style="background-color: #349CE4;"                        
                          label="Cancel"
                          icon="pi pi-times"
                          class="p-button mr-1 mb-1"
                          @click="reset"
                      />
                  </div>
                </Dialog>
  
                <Dialog
                  v-model:visible="deleteProductDialog"
                  :style="{ width: '450px' }"
                  header="Confirm"
                  :modal="true"
                >
                  <div class="flex align-items-center justify-content-center">
                    <i
                      class="pi pi-exclamation-triangle mr-3"
                      style="font-size: 2rem"
                    />
                    <span v-if="product"
                      >Are you sure you want to delete <b>{{ product.name }}</b
                      >?</span
                    >
                  </div>
                  <template #footer>
                    <Button
                      label="No"
                      icon="pi pi-times"
                      class="p-button-text"
                      @click="deleteProductDialog = false"
                    />
                    <Button
                      label="Yes"
                      icon="pi pi-check"
                      class="p-button-text"
                      @click="deletegroup"
                    />
                  </template>
                </Dialog>            
        </div>
      </div>
  </div> 

</template>

<script>
  import { FilterMatchMode } from "primevue/api";
  import ProductService from "../service/ProductService";
  import BreadcrumbService from "../service/BreadcrumbService";
  import JsonExcel from "vue-json-excel";
  import { GoogleMap, Marker,MarkerCluster,InfoWindow,GMapMarker,Polyline } from "vue3-google-map";
  import apis from "@/apis";
  import axios from "axios";
  import ProgressSpinner from 'primevue/progressspinner';


	export default {
		data() {
			return {
        rows:6,   
        rowsPerPage:6,
        perPageOptions: [6, 12, 18, 1000],   
				layout: 'grid',
				sortKey: null,
				sortOrder: null,
				sortField: null,
				sortOptions: [
					{label: 'Price High to Low', value: '!price'},
					{label: 'Price Low to High', value: 'price'},
				],
        status_dropdown: [
            { name: "Active", value: "Active" },
            { name: "InActive", value: "InActive" },
            { name: "Deleted", value: "Deleted" },
        ],
        type_dropdown: [
            { name: "Image", value: "image" },
            { name: "Video", value: "video" },
        ],
        type_selected:"",
        selected_type:"",
        search_status: "",
        vehicle_search:"",
        search_name:"",
        selectedvehicle:{ name: "", id: "" },
        selecteduser:{ name: "", id: "" },

        attachments:"", 
        previewImage: null,  
        item:{},   
      
        client_id_search:'',
        user_key:"",
        start:'',
        end:'',
        searchme:'',
        name:'',
        page_no:1,
        isLoading: false,
        isLoadingModel: false,
        loading: false,
        fullPage: true,
        file_attachment: "",

        pick_search:'',
        end_pick_search:'',
        user_type_search:'',

        selectgroupstatus:{name:"", value:""},
        selectedstatus: { name: "", value: "" },
        products: null,
        productDialog: false,
        deleteProductDialog: false,
        deleteProductsDialog: false,
        lazyParams: {},
        product: {},
        selectedProducts: null,
        filters: {},
        offset: 1,
        
        
        limit: 6,
        columns: [],
        pageno: 1,
        submitted: false,
        totalRecords: 0,
        id: "",
       
        BreadcrumbService : null,
        breadcrumbHome: {},
        breadcrumbItems: [],
			}
		},
		productService: null,
		async created() {
      this.initFilters();
      this.user_key=localStorage.getItem("user_key");    

      this.BreadcrumbService = new BreadcrumbService();
      let Breadcrum_data = this.BreadcrumbService.advertize()
      this.breadcrumbHome=Breadcrum_data.home;
      this.breadcrumbItems=Breadcrum_data.items;
		},
		async mounted() {
      this.id = this.$route.params.id;
  
      this.lazyParams = {
        first: 0,
        rows: this.limit,
        sortField: null,
        sortOrder: null,
        filters: this.filters,
      };
      if (this.totalRecords == 0) {
        await this.get_count();
      }
      await this.get_list();
		},
    watch: {
     async $route() {
        this.products = [];
        this.columns = [];
        this.totalRecords = 0;
        this.id = this.$route.params.id;
        if (this.id) {
          await this.get_count();
          this.get_list();
        }
      },
    },
  methods: { 
    async onPageChange(event) {
      this.currentPage = event.page + 1;
      this.page_no = event.page + 1;
      this.rows = event.rows;
      this.limit = event.rows;
      console.log( this.rows );
      await this.get_list();
      await this.get_count();
    },
    window_up()
    {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
      capitalizeFirstLetter(str) {
        if (str && typeof str === 'string') {
          return str.charAt(0).toUpperCase() + str.slice(1);
        } else {
          return '';
        }
      },
      isImage(url) {
        return /\.(jpeg|jpg|gif|png)$/i.test(url);
      },
      async handleFileUpload(event) {       
        var fileUp = event.files[0];
        if (fileUp) {
          this.previewImage = URL.createObjectURL(fileUp);
        }
        var file = fileUp;
        this.file = file;
        var prfeix = await this.date_time_prefix();
        var filename = prfeix + "_" + file.name.replace(/\s+/g, "_");
        // var filename = prfeix + "_" + file.name;
        this.file_data = {
          filePath: 'Entertainment/'+filename,
          contentType: file.type,
        };
        this.isLoadingModel = true;
        var promise = apis.upload_to_AWS(this.file_data);
        promise.then((response) => {
          axios
            .put(response.data.data, file, {
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": file.type,
              },
            })
            .then((response) => {
              this.isLoadingModel = false;
              
              this.attachments = "https://media.geoc.in/Entertainment/" + filename;
                console.log(this.attachments);
            });
        });
      },   
      async date_time_prefix() {
          const currentDateTime = new Date();
          const formattedDate = currentDateTime
              .toISOString()
              .split("T")[0]
              .replace(/-/g, "_");
          const formattedTime = currentDateTime
              .toTimeString()
              .split(" ")[0]
              .replace(/:/g, "_");
          const resultString = `${formattedDate}_${formattedTime}`;
          return resultString;
      },  
     
        isNumber(evt) {  
        const charCode = evt.which ? evt.which : evt.keyCode;  
        if (  
          charCode > 31 &&  
          (charCode < 48 || charCode > 57) &&  
          charCode !== 46  
        ) {  
          evt.preventDefault();  
        }  
      },  
  
      async search(count)
      { if (count==2) 
        {
          this.search_status= "";
          this.search_name="";
          this.type_selected="";
        }
        if(this.name!='' && this.name.length>100)
        {
          this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Valid Mobile Number",
          life: 3000,
        });
        return false;
        }
        await this.get_list();
        await this.get_count();
      },
      async viewProduct(product)
      {
        console.log(JSON.stringify(product));
        await localStorage.setItem('savegroupdata',JSON.stringify(product));
        this.$router.push({name:"groupProfile"});
      },
  
      async onPage(event) {
        this.lazyParams = event;
        this.page_no = event.page + 1;
        this.limit = event.rows;
        if (this.totalRecords > 0) {
          this.get_list();
        }
      },
      get_count: function () {
        var status='';
        if(this.search_status.value!='')
        {
          status=this.search_status.value;
        }
        var type_array=[];
        if(this.type_selected.length>0)
        {
          for (let index = 0; index < this.type_selected.length; index++) {
            type_array.push(this.type_selected[index].value);     
          }
        }       
        var data = {          
          count: true,
          status:status,
          name:this.search_name,
          type_array:type_array            
        };
        this.isLoadingModel = true;
        var promise = apis.GetAdList(data, this.id);
        promise.then((response) => {
          this.isLoadingModel = false;
          console.log(response);
          this.totalRecords = response.data.data;
        });
  
        console.log(data);
      },
      get_list: function () {
        var status='';
        if(this.search_status.value!='')
        {
          status=this.search_status.value;
        }    
        var type_array=[];
        if(this.type_selected.length>0)
        {
          for (let index = 0; index < this.type_selected.length; index++) {
            type_array.push(this.type_selected[index].value);     
          }
        }      
        var data = {
          limit: this.limit,
          page_no: this.page_no,
          count: false,
          status:status,
          name:this.search_name,
          type_array:type_array            
        };
        console.log(data);
        this.isLoadingModel = true;
        var promise = apis.GetAdList(data, this.id);
        promise.then((response) => {
          this.isLoadingModel = false;
          console.log(response);
          this.products = response.data.data;
          console.log(this.products[0]);
          if (this.columns.length == 0) {
            if (this.products.length > 0) {
              this.columns = Object.keys(this.products[0]);
            }
          }
        });
  
        console.log(data);
      },
     
      openNew() {
        this.product = {};
        this.submitted = false;
        this.productDialog = true;
        this.selected_type="";
      },
      hideDialog() {
        this.productDialog = false;
        this.submitted = false;
      },
    
      async adduser() {
        this.submitted = true;
        if (!this.product.name) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Advertizement name",
            life: 3000,
          });
          return false;
        }

        if (!this.selectedstatus.value) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select  Status",
            life: 3000,
          });
          return false;
        }

        if (!this.attachments) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please choose Image/Video for Advertizement",
            life: 3000,
          });
          return false;
        }

        var status='';
        if(this.selectedstatus!='')
        {
          status=this.selectedstatus.value;
        }
        console.log("status",status);

        //edit
        if (this.product._id) {
          var type = '';
          if (this.selected_type && this.selected_type.value!='') {
            type = this.selected_type.value;
          }
          // alert("edit");
            var data = {
              "_id":this.product._id,
              "status":status,
              "url":this.attachments,
              "name": this.product.name,                 
              "type":type,
              "description":this.product.description,
              "short_description":this.product.short_description,
              "created_by":"",
            };
          console.log(data);         
          // return false;
          this.isLoadingModel = true;
          var promise = apis.AdvertizementEdit(data);
          promise
            .then((responseapi) => {
              this.isLoadingModel = false;
              if (response.data.status==true) 
              {
                this.productDialog = false;
                this.$swal(response.data.message);
                this.get_list();
                this.get_count();
              } else 
              {
                this.$swal(response.data.message);
              }
            })
            .catch((error) => {
              //console.log(error);
              this.isLoadingModel = false;
              this.productDialog = false;
  
              this.$swal.fire(error.response.data);
              this.get_list();
              this.get_count();
            });
        }
        //add-----------------------------------------------------------------------------------------------------------------
        else {
          var type = '';
          if (this.selected_type && this.selected_type.value!='') {
            type = this.selected_type.value;
          }
          var data1 = {           
            "status":status,
            "url":this.attachments,
            "name": this.product.name,                 
            "type":type,
            "description":this.product.description,
            "short_description":this.product.short_description,
            "created_by":"",
          };
          console.log(data1);         
          // return false;
          this.isLoadingModel = true;
          var promises = apis.AdvertizementAdd(data1);
          promises
            .then((response) => {
              this.isLoadingModel = false;

              if (response.data.status==true) {
                this.productDialog = false;
                this.$swal(response.data.message);
                this.get_list();
                this.get_count();
              } else {
                this.$swal(response.data.message);
              }
              
            })
            .catch((error) => {
              //console.log(error);
              this.isLoadingModel = false;
              this.productDialog = false;
  
              this.$swal.fire(error.response.data);
              this.get_list();
              this.get_count();
            });
        }
      
      },
      reset()
      {
        this.product={};
        this.selectedstatus= { name: "", value: "" };
        this.attachments="";
        this.previewImage=null;
        this.productDialog = false;
      },

      format_time(data)
      {
        if(data) 
        {
          const date = new Date(data);
          return date;
        }
        else
        {
          return '';
        }

      },
     
      editProduct(product) {
        this.product = { ...product };
        if(this.product.url)
        {
            this.previewImage=this.product.url;
            this.attachments=this.product.url;
        }
        this.selected_type="";
        if (this.product.type && this.product.type=='video') 
        {
          this.selected_type={name:"Video" , value: "video"};
        }
        if (this.product.type && this.product.type=='image') 
        {
          this.selected_type={name: "Image", value: "image"};
        }
        this.selectedstatus.value = this.product.status;
        this.selectedstatus.name = this.product.status;
        this.productDialog = true;
      
      },
      confirmDeleteProduct(product) {
        this.product = product;
        this.deleteProductDialog = true;
      },
      deleteProduct() {
        this.products = this.products.filter((val) => val.id !== this.product.id);
        this.deleteProductDialog = false;
        this.product = {};
        this.$toast.add({
          severity: "success",
          summary: "Successful",
          detail: "Product Deleted",
          life: 3000,
        });
      },
  
      deletegroup() {
        if (this.product._id) {
          var data = {
            _id: this.product._id,
          };
          this.isLoadingModel = true;
          var promise = apis.AdvertizementDelete(data);
          promise.then((responseapi) => {
            this.isLoadingModel = false;
            if (responseapi.data.status == true) {
              this.deleteProductDialog = false;
              this.$swal(responseapi.data.message);
              this.get_list();
              this.get_count();
            } else {
              this.$swal("error to Delete Record");
            }
          });
        }
      },
  
      createId() {
        let id = "";
        var chars =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 5; i++) {
          id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
      },
      
     async  exportCSV() {
        this.limit=this.totalRecords;
        this.get_list();
       await this.$refs.dt.exportCSV();
      },
      confirmDeleteSelected() {
        this.deleteProductsDialog = true;
      },
   
      initFilters() {
        this.filters = {
          global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        };
      },
    },
    components: {downloadExcel: JsonExcel,GoogleMap, Marker,MarkerCluster,InfoWindow,GMapMarker,Polyline,ProgressSpinner},
	}
</script>

<style scoped lang="scss">
@import '../assets/demo/badges.scss';
.image-wrapper{
  height: 150px;
}
</style>
